
import setParallax from './lib/setParallax'
import scrollOver from './lib/getScrollOverElement'
import jumpjs from 'jump.js'

// setParallax({
//     el: '.section-header'
// })

scrollOver({
    el: '.section-festival',
    offset: 300,
    cb(el) {
        el.classList.add('is-visible')
    }
})

scrollOver({
    el: '.section-veranstalter',
    offset: 300,
    cb(el) {
        el.classList.add('is-visible')
    }
})

scrollOver({
    el: '.section-kontakt',
    offset: 300,
    cb(el) {
        el.classList.add('is-visible')
    }
})


function revealStart() {
    setTimeout(() => {
        document.querySelector('.section-start').classList.add('is-visible')
    }, 1000)
}

revealStart()


function jump() {

    let jumper = document.getElementById('jumper')

    jumper.addEventListener('click', () => {

        jumpjs('.section-festival', {
            duration: 1000,
            callback() {
                document.querySelector('.section-festival').classList.add('is-visible')
            }
        })
    })

}

jump()



// WEBPACK FOOTER //
// ./src/js/main.js